import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk, renderQuestionOkNotOkNa } from "../shared/templates";

const app = window.app;

export class MbCommunication extends HTMLElement {
	async connectedCallback() {
		await waitForContent("mbCommunication");

		this.innerHTML = app.content.mbCommunication;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton13", "nextButton13"));

		//prettier-ignore
		const questions = [
			["mer-hey-mercedes", "Hey Mercedes' activation", false],
			["mer-sirius",       "Sirius XM",                false],
			["mer-data",         "Data plan active",         true ],
			["mer-apple-music",  "Apple Music active",       true ],
			["mer-ridevue",      "Ridevue active",           true ],
			["mer-bluetooth",    "Bluetooth",                false],
		];

		for (const [name, label, na] of questions) {
			const render = na ? renderQuestionOkNotOkNa : renderQuestionOkNotOk;
			this.querySelector(`#${name}-slot`).replaceWith(render(name, label, 13));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(13, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			const currentRoute = app.routes.mbCommunication;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
